
import {defineComponent, PropType} from 'vue'
import TripPacket from "@/models/trip/TripPacket";

export default defineComponent({
  name: 'TripPacketComponent',
  props: {
    packet: {
      type: Object as PropType<TripPacket>,
      required: true
    },
    selectedPacket: {
      type: Object as PropType<TripPacket>,
      required: false
    }
  }
})
